import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
      <div>
		  
				<section className="davidvallejo-work" data-section="footer">
                <div class="vl"></div>
				<h3 style={{textAlign:"center", fontFamily: "'Helvetica Neue', serif",paddingBottom:2, marginBottom:0}}>Made with ❤️ By David Vallejo</h3>
				</section>
      </div>
    )
  }
}